@if (field.generateRows) {
    <tablewithfixedrows-component [field]="field" [isUpdate]="isUpdate" [useSummaryView]="useSummaryView"></tablewithfixedrows-component>
} @else {
    <tablewithvariablerows-component [field]="field" [isUpdate]="isUpdate" [useSummaryView]="useSummaryView"></tablewithvariablerows-component>
}